import { render, staticRenderFns } from "./WidgetArticleCard.vue?vue&type=template&id=4e853ce1&scoped=true&"
import script from "./WidgetArticleCard.vue?vue&type=script&lang=js&"
export * from "./WidgetArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./WidgetArticleCard.vue?vue&type=style&index=0&id=4e853ce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e853ce1",
  null
  
)

export default component.exports